<template>
    <div>
      <Breadtabsheader/>
        <div class="h-content w-content">
            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="返利时间" style="width: 50%;">
								<el-date-picker
										placeholder="请选择开始时间"
										v-model="q.startMonth"
										clearable
										type="month"
										value-format="yyyyMM"
										@change="checkDate()"
										:picker-options="billPickerOptions"
								>
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择结束时间"
										v-model="q.endMonth"
										clearable
										type="month"
										value-format="yyyyMM"
										@change="checkDate()"
										:picker-options="billPickerOptions"
								>
								</el-date-picker>
							</el-form-item>
							<el-form-item label="区域" prop="area">
								<brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true" :clearable="true"/>
							</el-form-item>
							<el-form-item label="领域" prop="field">
								<brselect category="fl_field" :v="q.field" v-model="q.field" :clearable="true"/>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="经销商编码" prop="agentCodeLike" style="width: 25%;">
										<el-input v-model="q.agentCodeLike" placeholder="请输入经销商编码"></el-input>
									</el-form-item>
									<el-form-item label="经销商名称" prop="agentNameLike" style="width: 25%;">
										<el-input v-model="q.agentNameLike" placeholder="请输入经销商名称"></el-input>
									</el-form-item>
									<el-form-item label="经销商类型" prop="agentType">
										<brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
						<div class="l-screenBox">
							<div class="l-screen" @click="collapseChange">
								<img :src="isScreen?closeScreen:drawScreen" alt="">
								<div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
							</div>
							<div class="l-retrieval">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
							</div>
						</div>
                    </el-form>
                </div>
            </div>
			<div class="h-table h-mrt30">
					<el-table
						  ref="f"
						  :data="tableData"
						  stripe
						  style="width: 100%"
						  :border="true"
						  :summary-method="getSummaries"
						   show-summary
						  max-height="530">
						<el-table-column
								prop="agentCode"
								:show-overflow-tooltip="true"
								label="经销商编码"
								fixed
						>
						</el-table-column>
						<el-table-column
								prop="agentName"
								:show-overflow-tooltip="true"
								label="经销商名称"
								fixed
						>
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.agentName}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="agentType"
								label="经销商类型"
								:show-overflow-tooltip="true"
								width="100">
							<template slot-scope="scope">
								{{scope.row.agentType|dictname('fl_agent_type')}}
							</template>
						</el-table-column>
						<el-table-column
								prop="area"
								:show-overflow-tooltip="true"
								label="区域"
						>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								label="链群"
						>传统
						</el-table-column>
						<el-table-column
							prop="field"
							:show-overflow-tooltip="true"
							label="领域"
						>
              <template slot-scope="scope">
                <div v-if="scope.row.field == 0">传统</div>
                <div v-if="scope.row.field != 0">{{scope.row.field|dictname('fl_field')}}</div>
              </template>
						</el-table-column>
						<el-table-column
							prop="rebateAmount"
							:show-overflow-tooltip="true"
							label="返利金额（元）"
						>
							<template slot-scope="scope">
								<div style="text-align: right;">{{scope.row.rebateAmount}}</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="yidui"
								:show-overflow-tooltip="true"
								label="已兑金额（元）"
						>
							<template slot-scope="scope">
								<div style="text-align: right;">{{scope.row.yidui}}</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="weidui"
								:show-overflow-tooltip="true"
								label="未兑金额（元）"
						>
							<template slot-scope="scope">
								<div style="text-align: right;">{{scope.row.weidui}}</div>
							</template>
						</el-table-column>
					</el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen: false,
				closeScreen: require("@/assets/images/pimg/closeallic.png"),
				drawScreen: require("@/assets/images/pimg/dobleArr.png"),
                //查询属性
                page: {
                    pageSize: 10,
                    pageNo: 1
                },
                q: {
					startMonth: null,
					endMonth: null,
                    areaCode: null,
                    field: null,
                    agentNameLike: null,
                    agentCodeLike:null,
					agentType:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                  isIncrement: 1,
                },
                //table列表
                tableData: [],
				countlist:'',
				billPickerOptions:{
					disabledDate: (time) => {
						var now = new Date();
						var year = now.getFullYear();
						var month = now.getMonth();
						return time.getTime() > new Date(year+'-'+month);
					}
				},
				spanArr:[]
            }
        },
        created() {
            this.handleFilter();
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
			checkDate(){
				var sd = this.q.startMonth;
				var ed = this.q.endMonth;
				if(sd && ed && sd > ed){
					this.$msg.msge("结束时间不能小于开始时间");
					this.q.endMonth = null;
				}
			},
			// 展开折叠
			collapseChange() {
				this.isScreen = !this.isScreen;
			},
            //重置
            reset() {
                this.q.startMonth = null;
                this.q.endMonth = null;
                this.q.agentNameLike = null;
                this.q.agentCodeLike=null;
				this.q.areaCode=null;
				this.q.field=null;
				this.q.agentType = null;
              this.q.isIncrement = 1;
            },
            handleFilter() {
				this.query();
				this.queryTotal();
            },
			query(){
				ss.fanli.rebateResultPage(this.q).then(rd => {
					this.q.total = rd.total;
					this.tableData = rd.records;
					this.getSpanArr();
				});
			},
			queryTotal(){
				ss.fanli.rebateResultTotal(this.q).then(rd => {
					this.countlist = rd;
				});
			},
            //返利批量导出
            exportExcel() {
				updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/rebateResultExcel", this.q, "post");
            },
			getSummaries(param){
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					console.log(column,index)
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[4] = '';
						sums[5] = '';
						sums[6] = Number(this.countlist.rebateAmount).toFixed(2);
						sums[7] = Number(this.countlist.yidui).toFixed(2);
						sums[8] = Number(this.countlist.weidui).toFixed(2);
					} else {
						sums[1] = '';
						sums[2] = '';
						sums[3] = '';
						sums[4] = '';
						sums[5] = '';
					}
				});

				return sums;
			},
			//合并单元格
			objectSpanMethod({row, column, rowIndex, columnIndex}) {
				//需要合并单元行的是哪几列
				if (column.label == "已兑金额（元）") {

					//从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
					const _row = this.spanArr[rowIndex];

					//该行跨了几列
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					}
				}

			},
			getSpanArr() {
				this.spanArr = [];
				this.tableData.forEach((item, index) => {
					if (index === 0) {
						this.spanArr.push(1);
						this.position = 0;
					} else {
						if (this.tableData[index].agentCode === this.tableData[index - 1].agentCode) {
							this.spanArr[this.position] += 1;
							this.spanArr.push(0);
						} else {
							this.spanArr.push(1);
							this.position = index;
						}
					}
				})
			},
        }
    }
</script>
<style lang="scss">
	.el-table thead.is-group th {
		background-color: #57aefe;
	}

	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}

	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}

	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}

	.el-table--scrollable-x .el-table__body-wrapper {
		z-index: 1;
	}

	.el-table__fixed-footer-wrapper tbody td {
		border-top: 0;
	}
</style>